/* eslint-disable unused-imports/no-unused-vars */
import { PersistentWorkItem } from './persistent-work-item';
import { PersistentWorkflow } from './persistent-workflow';
import { PersistentWorkflowContext } from './persistent-workflow-context';
import { PersistentWorkflowRunner } from './persistent-workflow-runner';

type PersistentDataType = any;
type TransitDataType = any;
type PersistentContextType = PersistentWorkflowContext<TransitDataType, PersistentDataType>;
type PersistentWorkItemType = PersistentWorkItem<PersistentContextType>;

/**
 * Abstract class of workflow builder.
 * An instance of this class will be used to build workflow.
 */
export abstract class PersistentWorkflowBuilder {
    /**
     * The collection of work items.
     */
    protected collection: PersistentWorkItem<any>[];

    /**
     * Initializes a new instance of the PersistentWorkflowBuilder abstract class.
     *
     * @param moduleName the module name.
     * @param name the name within the namespace.
     * @param version the version number.
     */
    constructor(protected moduleName: string, protected name: string, protected version: number) {
    }

    /**
     * Initializes the collection to before adding any work items.
     */
    protected init(): void {
        this.collection = [];
    }

    /**
     * Gets the workflow.
     */
    protected get workflow(): PersistentWorkflow {
        return {
            moduleName: this.moduleName,
            name: this.name,
            version: this.version,
            collection: this.collection
        };
    }

    /**
     * Add the work item single sequence pattern.
     *
     * @param workItem the work item.
     */
    protected addSequence<TRequest, TResult>(workItem: PersistentWorkItemType): void {
        workItem.id = this.collection.length + PersistentWorkflowRunner.startingId;
        workItem.nextId = -1;
        if (this.collection.length > 0) {
            this.collection[this.collection.length - 1].nextId = workItem.id;
        }

        this.add(workItem);
    }

    /**
     * Add the work item with custom sequence.
     *
     * @param workItem the work item.
     */
    protected add<TRequest, TResult>(workItem: PersistentWorkItemType): void {
        this.collection.push(workItem);
    }

    /**
     * Build the collection of work item for workflow.
     *
     * @returns the collection of work items.
     */
    abstract build(): PersistentWorkflow;
}
